const chatButton = value => {
  let number = value
  if (number.startsWith('0')) number = value.substring(1)
  if (number.startsWith('62')) number = value.substring(2)
  window.open(`https://wa.me/62${number}`)
}

export default chatButton
